export default __webpack_public_path__ + "static/media/atome.d2490649.jpg";